import { render, staticRenderFns } from "./CourseChapteeCreate.vue?vue&type=template&id=07655e8e&scoped=true&"
import script from "./CourseChapteeCreate.vue?vue&type=script&lang=js&"
export * from "./CourseChapteeCreate.vue?vue&type=script&lang=js&"
import style0 from "./CourseChapteeCreate.vue?vue&type=style&index=0&id=07655e8e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07655e8e",
  null
  
)

export default component.exports